export default function created() {
    /** Get today's journals **/
    // this.form.get();
}
